<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-chart-pie</v-icon>
        <span class="ml-2 title">Resultado de encuesta</span>
        <v-spacer />
        <v-btn
          fab
          small
          color="secondary"
          @click="$router.go(-1)"
        >
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col
            v-for="(item, index) in vfData"
            :key="index"
            cols="12"
            md="4"
          >
            <v-card>
              <v-card-text>
                <p class="title">{{ item.title }}</p>
                <PieChart :chart-data="item"></PieChart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            v-for="(item, index) in multipleData"
            :key="index"
            cols="12"
            md="6"
          >
            <v-card>
              <v-card-text>
                <p class="title">{{ item.title }}</p>
                <BarChart :chart-data="item"></BarChart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import BarChart from '../components/BarChart'
import PieChart from '../components/PieChart'
export default {
  props: {
    id: {
      type: String,
      default: () => null
    }
  },
  components: {
    BarChart,
    PieChart
  },
  data () {
    return {
      vfData: [],
      multipleData: []
    }
  },
  created () {
    this.getVF()
    this.getMultiple()
  },
  methods: {
    async getVF () {
      const { data } = await this.$http.preguntas.get(`?encuesta=${this.id}&tipo=vf`)
      const preguntas = data.map(i => ({
        label: i.pregunta,
        resultados: {
          si: i.respuestas.reduce((acc, item) => item.verdadero_falso ? acc + 1 : acc, 0),
          no: i.respuestas.reduce((acc, item) => !item.verdadero_falso ? acc + 1 : acc, 0)
        }
      }))
      this.vfData = preguntas.map(i => ({
        title: i.label,
        labels: ['Si', 'No'],
        datasets: [
          {
            label: i.label,
            backgroundColor: ['#4CAF50', '#F44336'],
            data: [i.resultados.si, i.resultados.no]
          }
        ]
      }))
    },
    async getMultiple () {
      const { data } = await this.$http.preguntas.get(`?encuesta=${this.id}&tipo=multiple`)
      const preguntas = data.map(i => {
        const resultados = i.opcions.map(j => ({
          label: j.valor,
          value: i.respuestas.filter(k => k.texto === j.valor).reduce((acc, l) => acc + 1, 0)
        }))
        return {
          label: i.pregunta,
          resultados
        }
      })
      this.multipleData = preguntas.map(i => ({
        title: i.label,
        labels: i.resultados.map(j => j.label),
        datasets: [
          {
            label: i.label,
            backgroundColor: ['#4CAF50', '#3F51B5', '#673AB7', '#009688', '#FF9800'],
            data: i.resultados.map(j => j.value)
          }
        ]
      }))
    }
  }
}
</script>
